//
// Action types
//

import { findIndex } from "lodash";

const DEFAULT_FILTERS_STATE = {
  terms: "",
  selectedThemes: [],
  bookmarkedOnly: false,
  mineOnly: false
};

export const UPDATE_SEARCH_TERMS = "UPDATE_SEARCH_TERMS";
export const UPDATE_SELECTED_THEMES = "UPDATE_SELECTED_THEMES";
export const ADD_SELECTED_THEME = "ADD_SELECTED_THEME";
export const REMOVE_SELECTED_THEME = "REMOVE_SELECTED_THEME";
export const TOGGLE_SELECTED_THEME = "TOGGLE_SELECTED_THEME";
export const UPDATE_BOOKMARKED_ONLY = "UPDATE_BOOKMARKED_ONLY";
export const UPDATE_MINE_ONLY = "UPDATE_MINE_ONLY";
export const CLEAR_ALL_FILTERS = "CLEAR_ALL_FILTERS";

//
// Action creators
//

export function updateSearchTerms(resourcesListKey, terms) {
  return {
    type: UPDATE_SEARCH_TERMS,
    resourcesListKey,
    terms
  };
}

export function updateSelectedThemes(resourcesListKey, selectedThemes) {
  return {
    type: UPDATE_SELECTED_THEMES,
    resourcesListKey,
    selectedThemes
  };
}

export function addSelectedTheme(resourcesListKey, theme) {
  return {
    type: ADD_SELECTED_THEME,
    resourcesListKey,
    theme
  };
}

export function removeSelectedTheme(resourcesListKey, theme) {
  return {
    type: REMOVE_SELECTED_THEME,
    resourcesListKey,
    theme
  };
}

export function toggleSelectedTheme(resourcesListKey, theme) {
  return {
    type: TOGGLE_SELECTED_THEME,
    resourcesListKey,
    theme
  };
}

export function updateBookmarkedOnly(resourcesListKey, bookmarkedOnly) {
  return {
    type: UPDATE_BOOKMARKED_ONLY,
    resourcesListKey,
    bookmarkedOnly
  };
}

export function updateMineOnly(resourcesListKey, mineOnly) {
  return {
    type: UPDATE_MINE_ONLY,
    resourcesListKey,
    mineOnly
  };
}

export function clearAllFilters(resourcesListKey) {
  return {
    type: CLEAR_ALL_FILTERS,
    resourcesListKey
  };
}

function updateSearchTermsHandler(state, terms) {
  return { ...state, terms };
}

function updateSelectedThemesHandler(state, selectedThemes) {
  return { ...state, selectedThemes };
}

function addSelectedThemeHandler(state, theme) {
  const selectedThemes = [...state.selectedThemes, theme];
  return { ...state, selectedThemes };
}

function removeSelectedThemeHandler(state, theme) {
  const selectedThemes = [...state.selectedThemes];
  const themeIndex = findIndex(selectedThemes, ({ id }) => id === theme.id);
  if (themeIndex < 0) return state;

  selectedThemes.splice(themeIndex, 1);
  return { ...state, selectedThemes };
}

function toggleSelectedThemeHandler(state, theme) {
  const selectedThemes = [...state.selectedThemes];
  const themeIndex = findIndex(selectedThemes, ({ id }) => id === theme.id);

  if (themeIndex < 0) {
    return addSelectedThemeHandler(state, theme);
  } else {
    return removeSelectedThemeHandler(state, theme);
  }
}

function updateBookmarkedOnlyHandler(state, bookmarkedOnly) {
  return { ...state, bookmarkedOnly };
}

function updateMineOnlyHandler(state, mineOnly) {
  return { ...state, mineOnly };
}

function clearAllFiltersHandler() {
  return { ...DEFAULT_FILTERS_STATE };
}

//
// Reducer and handlers
//

export function reduceSearch(state, action) {
  switch (action && action.type) {
    case UPDATE_SEARCH_TERMS:
      return updateSearchTermsHandler(state, action.terms);
    case UPDATE_SELECTED_THEMES:
      return updateSelectedThemesHandler(state, action.selectedThemes);
    case ADD_SELECTED_THEME:
      return addSelectedThemeHandler(state, action.theme);
    case REMOVE_SELECTED_THEME:
      return removeSelectedThemeHandler(state, action.theme);
    case TOGGLE_SELECTED_THEME:
      return toggleSelectedThemeHandler(state, action.theme);
    case UPDATE_BOOKMARKED_ONLY:
      return updateBookmarkedOnlyHandler(state, action.bookmarkedOnly);
    case UPDATE_MINE_ONLY:
      return updateMineOnlyHandler(state, action.mineOnly);
    case CLEAR_ALL_FILTERS:
      return clearAllFiltersHandler();

    default:
      return state || { ...DEFAULT_FILTERS_STATE };
  }
}
